<div class="login-top-bar">
  <div class="login-logo">
    <!-- Replace with the path to your logo image -->
    <img src="../../assets/img/Logo_bianco.png" alt="Logo" />
  </div>
  <div class="background-logo">
    <img src="../../assets/img/sfondo_frecce.png" alt="Background-logo" class="mt-4" />
  </div>
</div>
<div class="login-container">
  <h2 class="login-title">{{ 'REGISTRATION_COMPLETE.TITLE' | translate }}</h2>
  <h3 class="forgot-password-subtitle">{{ 'REGISTRATION_COMPLETE.SUBTITLE' | translate }}</h3>
  <button type="button" (click)="onLogin()" class="button-form-submit">
    {{ 'REGISTRATION_COMPLETE.BACK_TO_LOGIN' | translate }}
  </button>
  <div class="mt-5">
    <div class="login-footer justify-content-center">
      <div class="pb-3" id="icamRights">
        <span> &copy; {{ getYear() }} ICAM S.P.A - All rights reserved </span>
      </div>
    </div>
  </div>
</div>
